import { YouTube } from "../../../../src/components/embeddeds/youtube";
import { Niconico } from "../../../../src/components/embeddeds/niconico";
import * as React from 'react';
export default {
  YouTube,
  Niconico,
  React
};